import { sumHours } from '@/utils/duration';

export interface LaborItemDurationInput {
  estimatedHours: number | string | null | undefined;
  isOptional: boolean;
  selectedByDefault: boolean;
}

function usableHours(value: number | string | null | undefined): number | null {
  if (value == null) return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

/**
 * Planned hours a new work order gets from this service's labor steps (#4126).
 *
 * Mirrors the server: a required step is always copied and an optional step only
 * when it starts ticked (`isLaborItemChosen`, copy-service-details.ts), and the
 * planned duration is the sum of the copied steps' hours whenever any of them has
 * an hour value, zero included (`resolveServicePlannedDuration`,
 * packages/shared/src/scheduling/planned-duration.ts). Returns null when no
 * copied step has hours — only then does the catalog "Estimated duration" apply.
 */
export function defaultLaborPlannedHours(
  items: readonly LaborItemDurationInput[],
): number | null {
  const hours = items
    .filter((item) => !item.isOptional || item.selectedByDefault)
    .map((item) => usableHours(item.estimatedHours))
    .filter((value): value is number => value != null);
  return hours.length === 0 ? null : sumHours(hours);
}
